<form class="form-group flex column filter-form" [formGroup]="form" *ngIf="form">
  <div class="field flex column">
    <mat-label class="field-label">{{ "Filter.Form.Time" | translate }}</mat-label>
    <div class="dropdown-field">
      <app-date-range
      formControlName="dateRange"
      [showCustomDateOption]="true"
    ></app-date-range>
    </div>
  </div>
  <!-- Truck Ownership Type -->
  <div class="field flex column">
    <mat-label class="field-label">{{ "Filter.Form.OwnershipType" | translate }}</mat-label>
      <app-lazy-dropdown
        formControlName="ownershipType"
        [lookup]="OwnershipTypeOptions"
        [placeholder]="'Placeholder.SelectTruckOwnership' | translate"
      ></app-lazy-dropdown>
  </div>
</form>
